export enum InitialContractParams {
  partnerId = 'partnerId',
  partnerName = 'partnerName',
  svcId = 'svcId',
  settleId = 'settleId'
}
